import type { FC } from 'react';
import { useRef } from 'react';
import { MDText } from 'i18n-react';

import { Tooltip } from 'Storybook/core/Tooltip';

import texts from '../DownloadCSV.texts';

import type { DownloadCSVButtonTooltipProps } from './DownloadCSVButtonTooltip.types';

const T = new MDText(texts);

export const DownloadCSVButtonTooltip: FC<DownloadCSVButtonTooltipProps> = ({
	children,
	content = String(T.translate('tooltipLabel')),
	isDisabled = false,
}) => {
	const isNextOpenPrevented = useRef(false);

	return (
		<Tooltip
			content={content}
			onFocus={(event) => {
				isNextOpenPrevented.current = true;
				event.preventDefault();
			}}
			open={isDisabled ? false : undefined}
		>
			{children}
		</Tooltip>
	);
};
